import { create } from 'zustand';
import { AlertType } from '../features/alert/alert';

interface Store {
  add: (data: AlertType) => void;
  remove: (id: string) => void;
  alerts?: AlertType[];
  reset: () => void;
}

export const useAlertStore = create<Store>((set) => ({
  add: (data) => {
    const withUuid = { ...data, id: crypto.randomUUID() };
    set((store) => ({ ...store, alerts: [withUuid, ...(store.alerts || [])] }));
  },
  remove: (id) => {
    set((store) => ({ ...store, alerts: store.alerts?.filter((item) => item.id !== id) }));
  },
  reset: () => {
    set({ alerts: [] });
  },
}));
